import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmailRequestsPage } from '@features/admin/email-requests';
import { useAdminEmailRequestStore } from '@features/admin/email-requests/useAdminEmailRequestStore.ts';

const adminEmailRequestsSearchSchema = z.object({
  search: z.string().optional(),
  status: z.enum(['PENDING', 'RESOLVING', 'RESOLVED', 'FAILED']).optional(),
  notificationType: z.enum(['ORDER_CREATED_SUPPLIER', 'ORDER_CREATED_CLIENT', 'ORDER_STATUS_CHANGE_SUPPLIER', 'ORDER_STATUS_CHANGE_CLIENT']).optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminEmailRequestsSearch = z.infer<typeof adminEmailRequestsSearchSchema>;

export const Route = createFileRoute('/admin/email-requests/')({
  validateSearch: search => adminEmailRequestsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { search, status, notificationType, page, size } = ctx.search;
    useAdminEmailRequestStore.getState().loadEmailRequests({
      search,
      status,
      notificationType,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <EmailRequestsPage />;
}
